<template>
  <div class="rte" :class="{ 'rte--invalid': invalid }">
    <div class="rte__toolbar">
      <button type="button" class="rte__btn" @mousedown.prevent="exec('bold')" title="Negrita">
        <b>B</b>
      </button>
      <button type="button" class="rte__btn" @mousedown.prevent="exec('italic')" title="Cursiva">
        <i>I</i>
      </button>
      <button type="button" class="rte__btn" @mousedown.prevent="exec('insertUnorderedList')" title="Lista con viñetas">
        &#8226;&#8212;
      </button>
      <button type="button" class="rte__btn" @mousedown.prevent="exec('insertOrderedList')" title="Lista numerada">
        1&#8212;
      </button>
    </div>
    <div
      ref="editorEl"
      class="rte__content"
      contenteditable="true"
      @input="onInput"
      @paste.prevent="onPaste"
    ></div>
  </div>
</template>

<script>
export default {
  name: "RichTextEditor",
  props: {
    modelValue: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    invalid: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],

  mounted() {
    if (this.modelValue) {
      this.$refs.editorEl.innerHTML = this.modelValue;
    }
    if (this.placeholder) {
      this.$refs.editorEl.setAttribute("data-placeholder", this.placeholder);
    }
  },

  watch: {
    modelValue(val) {
      if (val !== this.$refs.editorEl.innerHTML) {
        this.$refs.editorEl.innerHTML = val;
      }
    },
  },

  methods: {
    exec(command) {
      this.$refs.editorEl.focus();
      document.execCommand(command, false, null);
      this.emit();
    },

    onInput() {
      this.emit();
    },

    onPaste(e) {
      const text = e.clipboardData.getData("text/plain");
      document.execCommand("insertText", false, text);
      this.emit();
    },

    emit() {
      this.$emit("update:modelValue", this.$refs.editorEl.innerHTML);
    },
  },
};
</script>

<style scoped>
.rte {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  overflow: hidden;
  background: #fff;
  transition: border-color .15s, box-shadow .15s;
}
.rte:focus-within {
  border-color: #86b7fe;
  box-shadow: 0 0 0 .25rem rgba(13,110,253,.25);
}
.rte--invalid {
  border-color: #dc3545;
}
.rte--invalid:focus-within {
  box-shadow: 0 0 0 .25rem rgba(220,53,69,.25);
}

.rte__toolbar {
  display: flex; gap: .25rem; padding: .35rem .5rem;
  background: #f8f9fa; border-bottom: 1px solid #dee2e6;
}
.rte__btn {
  padding: .15rem .55rem; background: #fff; border: 1px solid #ced4da;
  border-radius: .25rem; cursor: pointer; font-size: .85rem; line-height: 1.4;
  color: #212529; transition: background .1s;
}
.rte__btn:hover { background: #e9ecef; }

.rte__content {
  min-height: 90px; padding: .5rem .75rem;
  font-size: .95rem; outline: none; line-height: 1.5;
  color: #212529;
}
.rte__content:empty::before {
  content: attr(data-placeholder);
  color: #adb5bd; pointer-events: none;
}
.rte__content :deep(ul),
.rte__content :deep(ol) { padding-left: 1.4rem; margin: 0; }
.rte__content :deep(p)  { margin: 0 0 .3rem; }
</style>